import '../scss/app.scss';
import './bootstrap';

import '@/Assets/fontawesome-pro-6.5.1-web/css/all.min.css';
import '@/Assets/fontawesome-pro-6.5.1-web/css/fontawesome.min.css';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from 'ziggy-js';
import regions from './regions';
import vuetify from "./vuetify";

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: title => `${title} - ${appName}`,
    resolve: name => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(vuetify)
            .use(regions)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
